import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useAuth, useToast } from "_hooks";
import { useOnBoardingGs1 } from "partner/_hooks";
import { Button, Icon } from "components/atoms";
import Forbidden from "./Forbidden";
import { WEB_APP } from "_config/constants/app.constants";

const Auth0 = () => {
  const { loginWithToken } = useAuth();
  const {
    user,
    isAuthenticated,
    loginWithRedirect,
    getAccessTokenSilently
  } = useAuth0();

  const navigate = useNavigate();
  const { logoutAuth0, lookAndFeel, sendSignUp } = useOnBoardingGs1();
  const { partner } = useParams();
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(true);
  const [token, setToken] = useState();
  const [wrong, setWrong] = useState(false);
  const initialized = useRef(null);
  const { toast } = useToast();

  const fetch = useCallback(async () => {
    try {
      const tkn = await getAccessTokenSilently();
      setToken(tkn);
      setLoading(false);
    } catch (e) {
      loginWithRedirect();
    }
  }, [getAccessTokenSilently, loginWithRedirect]);

  const checkIt = useCallback(async () => {
    if (isAuthenticated) {
      let gln = user?.["https://syncfonia.com/gln"];
      let res = await sendSignUp({
        email: user?.email,
        auth0: {
          gln,
          token,
          roles: user?.["https://syncfonia.com/roles"]
        }
      });
      
      let { data, error } = res;
      
      if (error?.status?.code) {
        let notify = true;
        switch (error.status.code) {
          case 111:
            if (error?.data?.[0]?.tokenAccess) {
              await loginWithToken(error.data?.[0].tokenAccess).then(({ data: d }) => {
                if (!!d) {
                  notify = false;
                  window.location.replace(WEB_APP);
                }
              });
            }
            break;
          case 101:
            notify = false;
            setAllowed(false);
            break;
          default:
            break;
        }

        if (notify) {
          setWrong(true);
          toast("Ocurrió un problema enlazando los servicios", "error");
        }

      } else {
        setTimeout(() => navigate(`/partner/${partner}/userEmail`, { 
          state: {
            _id: data?._id,
            email: user.email,
            gln,
            token
          }
        }), 5000);
      }
    }
  }, [isAuthenticated, loginWithToken, navigate, partner, sendSignUp, toast, token, user]);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      setTimeout(() => fetch(), 500);
    }
  }, [fetch]);
  
  useEffect(() => { 
    if (loading === false) checkIt();
  }, [loading]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="h-full w-full flex flex-wrap gap-5 justify-center content-center ">
      {allowed && <>
        {wrong ?
          <Icon className="text-9xl text-[#FF0303]" icon="closeCircle" />
        :
          <Icon
            className="animate-spin text-9xl"
            icon="spinner"
            style={{
              color: lookAndFeel?.primary?.solid
            }}
          />
        }

        {process.env.NODE_ENV === "development" && <Button

            style={{backgroundColor: lookAndFeel?.primary?.solid}}
            onClick={() => logoutAuth0(partner)}
          >logout</Button>
        }
      </>}

      {!allowed && <Forbidden />}
    </div>
  );
};

export default Auth0;
